import StepIcon from "./stepIcon";
import Connector from "./connector";
import MUIStepper from "@mui/material/Stepper";

import { styled } from "@mui/material/styles";
import { Step, StepButton, StepLabel } from "@mui/material";

const CustomStepButton = styled(StepButton)(({ theme }) => {
    const { palette } = theme;
    const { dark } = palette;

    return ({
        "& .Mui-active": {
            color: `${dark.main} !important`,
            fontWeight: `bold !important`,
        },
        "& .Mui-completed": {
            color: `${dark.main} !important`,
        },
    })
});

interface IProps {
    activeStep: number;
    stepLabels: string[];
    canChangeStep?: boolean;
    hidenSequency?: boolean;
    onStepChange?: (index: number) => void;
    [key: string]: any;
}

const Stepper = ({ activeStep, stepLabels, canChangeStep, hidenSequency, onStepChange, ...rest }: IProps) => {
    return (
        <MUIStepper
            activeStep={activeStep}
            connector={<Connector />}
            nonLinear={canChangeStep}
            alternativeLabel={hidenSequency}
            {...rest}
        >
            {stepLabels.map((item, index: number) => (
                <Step color="#42424a" key={index}>
                    {hidenSequency
                        ? (canChangeStep
                            ? <CustomStepButton color="#42424a" onClick={() => { onStepChange && onStepChange(index + 1) }}>
                                {item}
                            </CustomStepButton>
                            : <StepLabel>{item}</StepLabel>
                        )
                        : <StepLabel StepIconComponent={StepIcon}> {index + 1 + ". " + item} </StepLabel>
                    }
                </Step>
            ))}
        </MUIStepper>
    );
};

export default Stepper;
